import React, { useState, useEffect, useRef, useCallback } from 'react';
import { FlightSearchDropdown } from './FlightSearchDropdown';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { addPopularDestination, fetchGalleryImageUpdate, getFlightSearchListData, getPopularDestinationsData, updatePopularAirportDestinations } from '../../services/userservice';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import imageConfig from '../../config/imageConfig';

const AddPopularAirportDestination = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [flightList, setFlightList] = useState([]);
    const [searchTermTo, setSearchTermTo] = useState('');
    const [flightListTo, setFlightListTo] = useState([]);
    const [destination, setDestination] = useState('');
    const [airportType, setAirportType] = useState('domestic');
    const [status, setStatus] = useState('active');
    const [showDropdownFrom, setShowDropdownFrom] = useState(false);
    const [showDropdownTo, setShowDropdownTo] = useState(false);
    const [selectDataFrom, setSelectDataFrom] = useState(null)
    const [selectDataTo, setSelectDataTo] = useState(null)
    const [metaTitle, setMetaTitle] = useState('');
    const [metaKeywords, setMetaKeywords] = useState('');
    const [metaDesc, setMetaDesc] = useState('');
    const [formData, setFormData] = useState([
         {
             name: "", image_url: "", status: ""
         },
     ]);
 const [imageURL, setImageURL] = useState(formData?.image_url)
 
   

    const navigate = useNavigate();
    const { id } = useParams();
    const inputRef = useRef(null);
    const dropdownRef = useRef(null);
    const inputRefTo = useRef(null);
    const dropdownRefTo = useRef(null);



    const debounce = (func, delay) => {
        let debounceTimer;
        return function (...args) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func(...args), delay);
        };
    };

    const fetchCountryList = useCallback(
        debounce(async (term) => {
            if (term) {
                try {
                    const data = await getFlightSearchListData(term);
                    setFlightList(data);
                } catch (error) {
                    console.error('Failed to fetch flight list', error);
                }
            } else {
                setFlightList([]);
            }
        }, 500),
        []
    );

    const fetchCountryListTo = useCallback(
        debounce(async (term) => {
            if (term) {
                try {
                    const data = await getFlightSearchListData(term);
                    setFlightListTo(data);
                } catch (error) {
                    console.error('Failed to fetch flight list', error);
                }
            } else {
                setFlightListTo([]);
            }
        }, 500),
        []
    );

    useEffect(() => {
        if (showDropdownFrom) {
            fetchCountryList(searchTerm);
        }
    }, [showDropdownFrom, searchTerm, fetchCountryList]);

    useEffect(() => {
        if (showDropdownTo) {
            fetchCountryListTo(searchTermTo);
        }
    }, [showDropdownTo, searchTermTo, fetchCountryListTo]);

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
        fetchCountryList(e.target.value);
    };

    const handleInputChangeTo = (e) => {
        setSearchTermTo(e.target.value);
        fetchCountryListTo(e.target.value);
    };


    const handleSelectFrom = (flight) => {
        setSelectDataFrom(flight);
        setShowDropdownFrom(false);
    }

    const handleSelectTo = (flight) => {
        setSelectDataTo(flight);
        setShowDropdownTo(false);
    }


    const handleClickOutside = (event) => {
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target) &&
            inputRef.current &&
            !inputRef.current.contains(event.target)
        ) {
            setShowDropdownFrom(false);
        }
        if (
            dropdownRefTo.current &&
            !dropdownRefTo.current.contains(event.target) &&
            inputRefTo.current &&
            !inputRefTo.current.contains(event.target)
        ) {
            setShowDropdownTo(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [data, setData] = useState(null)

     const handleGalleryChange = async (e) => {
            const files = Array.from(e.target.files);
            const formData = new FormData();
    
            files.forEach((file) => {
                formData.append('profile_pic', file);
                formData.append('type', "gallery");
            });
    
            try {
                const response = await fetchGalleryImageUpdate(formData);
                console.log("fetchGalleryImageUpdate", response?.data?.files)
                // setImageURL(response?.data?.files?.[0]?.image_url)
                setImageURL(response?.data?.files)
                console.log("Image upload successful:", response?.data?.files?.[0]?.image_url);
            } catch (error) {
                console.error("Error uploading image:", error);
            }
        };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // if (id && id !== "add") {
        //     if (!selectDataFrom || !selectDataTo || !airportType || !status) {
        //         alert("Please fill all required fields.");
        //         return;
        //     }
        // }

        const payload = {
            from_city: selectDataFrom?.city || data?.from_city,
            from_city_code: selectDataFrom?.cityCode || data?.from_city_code,
            from_city_airport: selectDataFrom?.name || data?.from_city_airport,
            to_city: selectDataTo?.city || data?.to_city,
            to_city_code: selectDataTo?.cityCode || data?.to_city_code,
            to_city_airport: selectDataTo?.name || data?.to_city_airport,
            status: status || data?.status,
            flight_category: airportType,
            description: destination,
            meta_title: metaTitle,
            meta_keywords: metaKeywords,
            meta_description: metaDesc,
            image_url: imageURL?.[0]?.image_url || data?.image_url,
        };
        try {
            const response = id && id !== "add"
                ? await updatePopularAirportDestinations(id, payload)
                : await await addPopularDestination(payload);

            navigate('/popular-airPort-destination');
        } catch (error) {
            console.error('Error adding destination:', error);
            alert('Failed to add popular destination. Please try again.');
        }
    };


    useEffect(() => {
        if (id && id !== "add") {
            fetchManageDestinationsData(id);
        }
    }, [id]);

    const fetchManageDestinationsData = async (id) => {
        try {
            setLoading(true);
            const response = await getPopularDestinationsData(id);
            if (response) {
                setData(response?.data)
                setDestination(response?.data?.description)
                setAirportType(response?.data?.flight_category || '');
                setStatus(response?.data?.status || '');
                setMetaTitle(response?.data?.meta_title)
                setMetaKeywords(response?.data?.meta_keywords)
                setMetaDesc(response?.data?.meta_description)
                setImageURL(response?.data?.image_url)
            }
        } catch (error) {
            setError(error.message || "An error occurred while fetching destination data.");
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        if (showDropdownFrom && inputRef.current) {
            inputRef.current.focus();
        }
        if (showDropdownTo && inputRefTo.current) {
            inputRefTo.current.focus();
        }
    }, [showDropdownFrom, showDropdownTo]);

    const handleMetaDataInputChange = (event, type) => {
        const value = event.target.value;
        const setter = {
          metaTitle: setMetaTitle,
          metaKeywords: setMetaKeywords,
          metaDesc: setMetaDesc,
        }[type];
      
        if (setter) {
          setter(value);
        }
      };

    return (

        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>Add Popular Airport Destination</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Add Popular Airport Destination</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">

                            <div className="row mt-3">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label className='from-title cursor-pointer'>From City</label>
                                        <button
                                            className='flight_from-search-btn'
                                            aria-label="Select City"
                                            onClick={() => setShowDropdownFrom(!showDropdownFrom)}
                                        >
                                            {id ? <span className='flight-select-title'>{selectDataFrom?.city || data?.from_city}</span> :
                                                <span className='flight-select-title'>{selectDataFrom?.city || "Select City"}</span>}
                                        </button>
                                        {showDropdownFrom && (
                                            <div ref={dropdownRef} className="search-list-container">
                                                <input
                                                    placeholder="From ..."
                                                    ref={inputRef}
                                                    value={searchTerm}
                                                    onChange={handleInputChange}
                                                    style={{ height: "40px" }}
                                                />
                                                {flightList?.data?.length > 0 && (
                                                    <div className="popular-cities">
                                                        <h6>Suggested Cities</h6>
                                                    </div>
                                                )}
                                                <ul className='search-list'>
                                                    {flightList?.data?.map((city, index) => (
                                                        <li key={index} onClick={() => handleSelectFrom(city)} className="flight-item">
                                                            <span className="airportTitle">{`${city.city} (${city.cityCode})`}</span><br />
                                                            <span className="airportSubTitle">{city.name}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>

                                </div>

                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label className='from-title'>Airport Code</label>
                                        <button
                                            className='flight_from-search-btn disabled_button'
                                            aria-label="Select City"
                                        >
                                            <div className="row" style={{ cursor: "not-allowed" }}>
                                                {id ? <span className='flight-select-title'>{selectDataFrom?.cityCode || data?.from_city_code}</span> :
                                                    <span className='flight-select-title'>{selectDataFrom?.cityCode || "Code"}</span>}
                                            </div>
                                        </button>
                                    </div>

                                </div>

                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label className='from-title'>Airport Name</label>
                                        <button
                                            className='flight_from-search-btn disabled_button'
                                            aria-label="Select City"
                                        >
                                            <div className="row" style={{ cursor: "not-allowed" }}>
                                                {id ? <span className='flight-select-title'>{selectDataFrom?.name || data?.from_city_airport}</span> :
                                                    <span className='flight-select-title' >{selectDataFrom?.name || "Airport Name"}</span>}

                                            </div>
                                        </button>

                                    </div>

                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label className='from-title cursor-pointer'>To City</label>
                                        <button
                                            className='flight_from-search-btn'
                                            aria-label="Select To City"
                                            onClick={() => setShowDropdownTo(!showDropdownTo)}
                                        >
                                            {id ? <span className='flight-select-title'>{selectDataTo?.city || data?.to_city}</span> :
                                                <span className='flight-select-title'>{selectDataTo?.city || "Select City"}</span>}

                                        </button>
                                        {showDropdownTo && (
                                            <div ref={dropdownRefTo} className="search-list-container">
                                                <input
                                                    placeholder="To ..."
                                                    ref={inputRefTo}
                                                    value={searchTermTo}
                                                    onChange={handleInputChangeTo}
                                                    style={{ height: "40px" }}
                                                />
                                                {flightListTo?.data?.length > 0 && (
                                                    <div className="popular-cities">
                                                        <h6>Suggested Cities</h6>
                                                    </div>
                                                )}
                                                <ul className='search-list'>
                                                    {flightListTo?.data?.map((city, index) => (
                                                        <li key={index} onClick={() => handleSelectTo(city)} className="flight-item">
                                                            <span className="airportTitle">{`${city.city} (${city.cityCode})`}</span><br />
                                                            <span className="airportSubTitle">{city.name}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>


                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label className='from-title'>Airport Code</label>
                                        <button
                                            className='flight_from-search-btn disabled_button'
                                            aria-label="Select City"

                                        >
                                            <div className="row" style={{ cursor: "not-allowed" }}>
                                                {id ? <span className='flight-select-title'>{selectDataTo?.cityCode || data?.to_city_code}</span> :
                                                    <span className='flight-select-title'>{selectDataTo?.cityCode || "Code"}</span>}

                                            </div>
                                        </button>
                                    </div>

                                </div>

                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label className='from-title'>Airport Name</label>
                                        <button
                                            className='flight_from-search-btn disabled_button'
                                            aria-label="Select City"
                                        >
                                            <div className="row" style={{ cursor: "not-allowed" }}>
                                                <span className="flight-select-title">
                                                    {id ? (selectDataTo?.name || data?.to_city_airport) : (selectDataTo?.name || "Airport Name")}
                                                </span>
                                            </div>

                                        </button>
                                    </div>

                                </div>
                            </div>

                            <div className="col-sm-12">
                                <div className="form-group">
                                    <label>Destination Description</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={destination}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setDestination(data);
                                        }}
                                    />
                                </div>
                            </div>
                             <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label>Image (Upload Images)</label>
                                                    <input
                                                        type="file"
                                                        multiple
                                                        className="form-control"
                                                        onChange={handleGalleryChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">

                                                {imageURL && imageURL?.length > 0 ? (
                                                    <>
                                                        <label>Uploaded Image</label>
                                                        <br />

                                                        {/* {imageURL?.map((img, index) => ( */}
                                                        {/* <div className="col-sm-3" key={index}> */}
                                                        <img
                                                           // src={imageURL?.[0]?.image_url || imageURL}
                                                            src ={imageURL?.[0]?.image_url?.startsWith('https')? imageURL?.[0]?.image_url
                                                                                                        : imageURL?.[0]?.image_url
                                                                                                        ? imageConfig.GALLERY_IMAGE_URL + imageURL?.[0]?.image_url: ''}
                                                            style={{ width: "100%", borderRadius: '10px' }}
                                                        />
                                                        {/* </div> */}
                                                        {/* ))} */}

                                                    </>
                                                ) : null}



                                            </div>

                            <div className="row mt-2">
                                <div className="col-sm-12 mb-4">
                                        <button type="button" className="btn btn-success mt-2">
                                            Meta Tags
                                        </button>
                                </div>

                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <label>Meta Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="meta_title"
                                            value={metaTitle}
                                            onChange={(e) => handleMetaDataInputChange(e, 'metaTitle')}
                                            placeholder="Enter Meta Title"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <label>Meta Keyword</label>
                                        <textarea
                                            type="text"
                                            className="form-control"
                                            name="meta_keyword"
                                            value={metaKeywords}
                                            onChange={(e) => handleMetaDataInputChange(e, 'metaKeywords')}
                                            placeholder="Enter Meta Keyword"
                                            required
                                            rows="4"
                                            cols="50"
                                        />
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <label>Meta Description</label>
                                        <textarea
                                            type="text"
                                            className="form-control"
                                            name="meta_description"
                                            value={metaDesc}
                                            onChange={(e) => handleMetaDataInputChange(e, 'metaDesc')}
                                            placeholder="Enter Meta Description"
                                            required
                                            rows="4"
                                            cols="50"
                                        />
                                    </div>
                                </div>

                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Airport Type</label>
                                        <select
                                            className="form-control"
                                            value={airportType}
                                            onChange={(e) => setAirportType(e.target.value)}

                                        >
                                            <option value="">Select</option>
                                            <option value="domestic">domestic</option>
                                            <option value="international">international</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-sm-4">
                                    <div className="form-group">
                                        <label>Status</label>
                                        <select
                                            className="form-control"
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}

                                        >

                                            <option value="">Select</option>
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                            </div>


                            <button onClick={handleSubmit} className="btn btn-primary mt-5">
                                Save Destination
                            </button>
                        </div>
                    </div>

                </div>
            </section>
        </div>
    );
};

export default AddPopularAirportDestination;
